import { useQuery } from '@tanstack/react-query'
import { ReapitConnectBrowserSession } from '@reapit/connect-session'
import { useSnack } from '@reapit/elements'

import { reapitConnectBrowserSession } from '@reapit-sales/reapit-connect'
import { handleApiQuery } from '@reapit-sales/utilities'

import { createApiClient } from '../client/apiClient'

const getRCAccessToken = async (
  reapitConnectBrowserSession: ReapitConnectBrowserSession,
): Promise<string | undefined> => {
  const connectSession = await reapitConnectBrowserSession.connectSession()
  const accessToken = connectSession?.accessToken

  return accessToken
}

export const usePlatformGetProductIds = ({
  headers,
  enabled = true,
}: {
  headers?: Record<string, string>
  enabled?: boolean
} = {}) => {
  return useQuery({
    queryKey: ['platformProductIds'],
    queryFn: handleApiQuery(useSnack())(async () => {
      const accessToken = await getRCAccessToken(reapitConnectBrowserSession)

      const apiClient = createApiClient({
        baseURL: process.env.PLATFORM_API_URL,
        headers: {
          'Content-Type': 'application/json',
          'api-version': '2020-01-31', // Hardcoded API Version when it was introduced
          ...headers,
          Authorization: `Bearer ${accessToken}`,
        },
      })

      const response = await apiClient.get('/organisations/Users/self')
      return response.data
    }),
    enabled,
    refetchOnWindowFocus: false,
  })
}
